import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { getInitialPublicLocale, savePublicLocale } from '../utils/localePreference';
import { getLoginV2, getSupportV2, getUidMgmtV2, getSuperadminV2 } from '../locales/v2PublicUi';
import {
  getProjectLoginLocale,
  getGroupsPageLocale,
  getMoreDetailsLocale,
  getDrawerAppBarLocale,
  getTrendsPageLocale,
  getTimeRangeLocale,
  getAlarmsPageLocale,
} from '../locales/projectAppLocale';
import { getProjectModulesLocale } from '../locales/projectModulesLocale';
import { getModuleStoreLocale } from '../locales/moduleStoreLocale';

const PublicUiLocaleContext = createContext(null);

export function PublicUiLocaleProvider({ children }) {
  const [lang, setLangState] = useState(() => getInitialPublicLocale());

  const setLang = useCallback((next) => {
    const v = next === 'uk' ? 'uk' : 'en';
    savePublicLocale(v);
    setLangState(v);
  }, []);

  const value = useMemo(() => {
    const safe = lang === 'uk' ? 'uk' : 'en';
    return {
      lang: safe,
      setLang,
      login: getLoginV2(safe),
      support: getSupportV2(safe),
      uidMgmt: getUidMgmtV2(safe),
      sa: getSuperadminV2(safe),
      projectLogin: getProjectLoginLocale(safe),
      groups: getGroupsPageLocale(safe),
      md: getMoreDetailsLocale(safe),
      drawer: getDrawerAppBarLocale(safe),
      trends: getTrendsPageLocale(safe),
      timeRange: getTimeRangeLocale(safe),
      alarms: getAlarmsPageLocale(safe),
      projectModules: getProjectModulesLocale(safe),
      moduleStore: getModuleStoreLocale(safe),
    };
  }, [lang, setLang]);

  return <PublicUiLocaleContext.Provider value={value}>{children}</PublicUiLocaleContext.Provider>;
}

PublicUiLocaleProvider.propTypes = {
  children: PropTypes.node,
};

export function usePublicUiLocale() {
  const ctx = useContext(PublicUiLocaleContext);
  if (!ctx) {
    throw new Error('usePublicUiLocale must be used within PublicUiLocaleProvider');
  }
  return ctx;
}
